import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import MediumModal from "../../../../components/modals/MediumModal";
import {
  closeLabOrderDirectResultModal,
  openLabOrderGeneralResultModal,
  updateLabOrderDirectResultModal,
} from "../../../../redux/actions/modals";
import { sendLabOrderResult } from "../../../../redux/actions/orders";
import toaster from "../../../../utils/toaster";
const SendLabDirectResultComponent = (props) => {
  const dispatch = useDispatch();
  const {
    direct_lab_result_order_open,
    direct_result_lab_order,
    direct_result_lab_order_form,
  } = useSelector((state) => state.modals);
  const { send_lab_order_result_waiting } = useSelector(
    (state) => state.orders
  );
  const submit = () => {
    if (
      direct_result_lab_order_form.to.trim() === "" ||
      direct_result_lab_order_form.by.trim() === ""
    ) {
      toaster.error("اطلاعات به طور کامل وارد نشده است");
      return;
    }
    let body = {
      method: "direct",
      to: direct_result_lab_order_form.to,
      by: direct_result_lab_order_form.by,
    };
    dispatch(sendLabOrderResult(direct_result_lab_order.id, body));
  };
  return (
    <MediumModal
      header="نتیجه مستقیما به کاربر ارسال شد"
      show={direct_lab_result_order_open}
      closeFunction={closeLabOrderDirectResultModal}
    >
      <div className="lab-direct-result-form-holder">
        <div className="form-holder">
          <div className="form-group row">
            <label className="col-sm-12 col-form-label">
              نتیجه را به چه شماره‌ای ارسال کردید‌؟
            </label>
            <div className="col-sm-12">
              <input
                type="text"
                className="form-control"
                placeholder="مثال : ۰۹۱۲۳۴۵۶۷۸۹"
                onChange={(e) => {
                  dispatch(
                    updateLabOrderDirectResultModal(direct_result_lab_order, {
                      ...direct_result_lab_order_form,
                      to: e.target.value,
                    })
                  );
                }}
                value={direct_result_lab_order_form.to}
              />
            </div>
            <label className="col-sm-12 col-form-label">
              نتیجه را از چه طریق به کاربر ارسال کردید‌؟
            </label>
            <div className="col-sm-12">
              <input
                type="text"
                className="form-control"
                placeholder="مثال : واتس‌اپ یا پیامک"
                onChange={(e) => {
                  dispatch(
                    updateLabOrderDirectResultModal(direct_result_lab_order, {
                      ...direct_result_lab_order_form,
                      by: e.target.value,
                    })
                  );
                }}
                value={direct_result_lab_order_form.by}
              />
              <small className="text-muted">
                پاسخ سوال بالا به کاربر پیامک می‌شود.
              </small>
            </div>
          </div>
          <div className="form-group row sampling-order-action-buttons">
            <div className="col-sm-6">
              <CustomButton
                action={submit}
                loading={send_lab_order_result_waiting}
                content={"تایید و ارسال"}
                type={"success"}
                block={true}
                textWhite={true}
              />
            </div>
            <div className="col-sm-6">
              <button
                className="btn btn-small btn-outline-black full-width"
                onClick={() => {
                  dispatch(closeLabOrderDirectResultModal());
                  dispatch(
                    openLabOrderGeneralResultModal(direct_result_lab_order)
                  );
                }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>
    </MediumModal>
  );
};
export default SendLabDirectResultComponent;
